import * as React from 'react'
import { MetricCircle } from 'src/components/MetricCircle'
import HazarComs from 'src/assets/images/HazardComs.svg';

export const HazardCircle = ({ }) => (
  <MetricCircle style={{ margin: 'auto' }} circleIcon={
    <img src={HazarComs} alt="" style={{ color: 'red', fontSize: '.5rem' }} />
  } color='#f7d5d0' />
)